export enum EntityType{
  Fundraisers = 'Fundraisers',
  Events = "Events",
  FundCodes = "FundCodes",
  ParentDonors = "ParentDonors",
  Vendors ="Vendors",
  GLAccounts ="GLAccounts"
}

export enum DonorType {
  Candidate = 1,
  CampaignCommittee = 2,
  Coalation = 3,
  NonFederalCommittee = 4,
  Corporate = 5,
  Corporation = 6,
  Individual = 7,
  LLC = 8,
  Partnership = 9,
  NonQualifiedPoliticalActCommittee = 12,
  Organization = 13,
  QualifiedPoliticalActionCommittee = 14
}

export enum AsyncJobType {
  CalculateJFCDistributions = 1,
  JFCSaveAllocations = 2
}
